import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Dialog, Modal } from 'react-aria-components';
import { selectApiErrors } from '@features/advanced-errors/store/selectors';
import { clearApiErrors } from '@features/advanced-errors/store/slice';
import ApiErrorElement from '@features/advanced-errors/ApiErrorElement';



const AdvancedErrorsModal = () => {
	const { t } = useTranslation('global');

	const apiErrors = useSelector(selectApiErrors);
	const dispatch = useDispatch();
	const runClearApiErrors = () => dispatch(clearApiErrors());
	
	return (
		<Modal
			isOpen={apiErrors && apiErrors.length > 0}
			className='react-aria-Modal advanced-errors-modal'
		>
			<Dialog aria-label='advanced errors modal'>

				{apiErrors.map(x =>
					<ApiErrorElement error={x} key={`api-error-element-${x.requestId}`}/>)
				}

				<Button className='app-disabled-button btn' onPress={runClearApiErrors}>
					{t('appButtons.close')}
				</Button>

			</Dialog>
		</Modal>
	)
}

export default memo(AdvancedErrorsModal);